// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.softlite-typography-control .components-base-control{
    margin-bottom: 20px;
}
.softlite-typography-toggle-control{
    border: 1px solid #d6cfcf !important;
}
.softlite-typography-toggle-control .softlite-typography-toggle-control-option{
    border-right: 1px solid #d6cfcf;
}
.softlite-sizing-text-control label, .softlite-typography-control .components-base-control__label{
    text-transform: capitalize !important;
    font-size: 13px !important;
    font-weight: 400 !important;
}
.softlite-typography-control .softlite-color-box{
    margin-bottom: 10px;
}`, "",{"version":3,"sources":["webpack://./assets/js/src/controls/typography/typography.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;AACvB;AACA;IACI,oCAAoC;AACxC;AACA;IACI,+BAA+B;AACnC;AACA;IACI,qCAAqC;IACrC,0BAA0B;IAC1B,2BAA2B;AAC/B;AACA;IACI,mBAAmB;AACvB","sourcesContent":[".softlite-typography-control .components-base-control{\r\n    margin-bottom: 20px;\r\n}\r\n.softlite-typography-toggle-control{\r\n    border: 1px solid #d6cfcf !important;\r\n}\r\n.softlite-typography-toggle-control .softlite-typography-toggle-control-option{\r\n    border-right: 1px solid #d6cfcf;\r\n}\r\n.softlite-sizing-text-control label, .softlite-typography-control .components-base-control__label{\r\n    text-transform: capitalize !important;\r\n    font-size: 13px !important;\r\n    font-weight: 400 !important;\r\n}\r\n.softlite-typography-control .softlite-color-box{\r\n    margin-bottom: 10px;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
